// extracted by mini-css-extract-plugin
export default {"nhima-header":"Header_nhima-header__YFoHl","nhima-header__buttons":"Header_nhima-header__buttons__07al+"};